import { render, staticRenderFns } from "./KanjiPrint.vue?vue&type=template&id=10fd029c&scoped=true"
import script from "./KanjiPrint.vue?vue&type=script&lang=js"
export * from "./KanjiPrint.vue?vue&type=script&lang=js"
import style0 from "./KanjiPrint.vue?vue&type=style&index=0&id=10fd029c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd029c",
  null
  
)

export default component.exports